/**
 * HEIC — what an iPhone saves photographs as.
 *
 * The Worker converts them on arrival (only Safari can show one, and no vision model
 * reads one), so the browser's only job is to let them through. Off Apple's own
 * systems a browser often has no type for a .heic at all and reports `file.type` as
 * empty, so the name is checked as well as the type.
 */
export const HEIC_ACCEPT = 'image/heic,image/heif,.heic,.heif'

export const isHeic = (file) =>
  /^image\/hei[cf]$/.test(file?.type ?? '') || /\.hei[cf]$/i.test(file?.name ?? '')
